import { Appointment } from '../types';

export const dummyAppointments: Appointment[] = [
  // Today's appointments
  {
    id: 'today-1',
    patientId: '1',
    patientName: 'Maria Elena Rodriguez',
    date: new Date().toISOString().split('T')[0],
    time: '10:00',
    type: 'consultation',
    status: 'confirmed',
    duration: 30,
    notes: 'Follow-up consultation for recent dental work',
    aiBooked: true,
    assignedDoctor: 'Dr. Estrabillo'
  },
  {
    id: 'today-2',
    patientId: '2',
    patientName: 'James Patterson',
    date: new Date().toISOString().split('T')[0],
    time: '14:30',
    type: 'cleaning',
    status: 'scheduled',
    duration: 60,
    notes: 'Regular cleaning and checkup - Booked via phone call',
    aiBooked: true,
    assignedDoctor: 'Dr. Martinez'
  },
  {
    id: '1',
    patientId: '1',
    patientName: 'Maria Elena Rodriguez',
    date: '2025-01-15',
    time: '09:00',
    type: 'cleaning',
    status: 'scheduled',
    duration: 60,
    notes: 'Regular cleaning and checkup',
    aiBooked: false,
    assignedDoctor: 'Dr. Chen'
  },
  {
    id: '2',
    patientId: '2',
    patientName: 'James Patterson',
    date: '2025-01-16',
    time: '14:30',
    type: 'consultation',
    status: 'confirmed',
    duration: 30,
    notes: 'Consultation for crown replacement - Booked via email',
    aiBooked: true,
    assignedDoctor: 'Dr. Estrabillo'
  },
  {
    id: '3',
    patientId: '3',
    patientName: 'Dr. Ashley Chen',
    date: '2025-01-20',
    time: '11:00',
    type: 'procedure',
    status: 'scheduled',
    duration: 90,
    notes: 'Root canal procedure - AI scheduled from SMS request',
    aiBooked: true,
    assignedDoctor: 'Dr. Chen'
  },
  {
    id: '4',
    patientId: '4',
    patientName: 'Roberto Gonzalez',
    date: '2025-01-17',
    time: '08:30',
    type: 'followup',
    status: 'scheduled',
    duration: 30,
    notes: 'Post-procedure follow-up',
    aiBooked: false,
    assignedDoctor: 'Dr. Martinez'
  },
  {
    id: '5',
    patientId: '5',
    patientName: 'Jennifer Walsh',
    date: '2025-02-05',
    time: '13:00',
    type: 'cleaning',
    status: 'scheduled',
    duration: 60,
    notes: 'Routine cleaning with sedation - AI booked via phone',
    aiBooked: true,
    assignedDoctor: 'Dr. Johnson'
  }
];

// Add Malorie Down's appointments
const today = new Date().toISOString().split('T')[0];

// Today - First Visit
dummyAppointments.push({
  id: 'malorie-1',
  patientId: '56',
  patientName: 'Malorie Down',
  date: today,
  time: '09:30',
  type: 'consultation',
  status: 'scheduled',
  duration: 60,
  notes: 'First visit - initial consultation and examination - AI booked via call',
  aiBooked: true,
  assignedDoctor: 'Dr. Estrabillo'
});

// 2nd October - Consultation and Examination
dummyAppointments.push({
  id: 'malorie-2',
  patientId: '56',
  patientName: 'Malorie Down',
  date: '2025-10-02',
  time: '10:00',
  type: 'consultation',
  status: 'scheduled',
  duration: 90,
  notes: 'Consultation and Examination for wisdom teeth',
  aiBooked: false,
  assignedDoctor: 'Dr. Chen'
});

// 5th October - Pre-operative Antibiotic Therapy
dummyAppointments.push({
  id: 'malorie-3',
  patientId: '56',
  patientName: 'Malorie Down',
  date: '2025-10-05',
  time: '14:00',
  type: 'procedure',
  status: 'scheduled',
  duration: 30,
  notes: 'Pre-operative Antibiotic Therapy',
  aiBooked: false,
  assignedDoctor: 'Dr. Chen'
});

// 6th October - Wisdom Teeth Extraction
dummyAppointments.push({
  id: 'malorie-4',
  patientId: '56',
  patientName: 'Malorie Down',
  date: '2025-10-06',
  time: '11:00',
  type: 'procedure',
  status: 'scheduled',
  duration: 120,
  notes: 'Wisdom Teeth Extraction',
  aiBooked: false,
  assignedDoctor: 'Dr. Chen'
});

// Generate additional appointments
const appointmentTypes: Array<Appointment['type']> = ['cleaning', 'consultation', 'emergency', 'procedure', 'followup'];
const statuses: Array<Appointment['status']> = ['scheduled', 'confirmed', 'completed', 'cancelled'];
const doctors = ['Dr. Estrabillo', 'Dr. Martinez', 'Dr. Chen', 'Dr. Johnson'];
const bookingMethods = [
  'AI booked via phone call',
  'AI scheduled from email',
  'AI booked via SMS',
  'Staff booked',
  'AI booked via voicemail'
];

for (let i = 6; i <= 25; i++) {
  const date = new Date();
  // Generate dates within ±30 days but exclude weekends
  let randomDate;
  do {
    randomDate = new Date();
    randomDate.setDate(randomDate.getDate() + Math.floor(Math.random() * 60 - 30));
  } while (randomDate.getDay() === 0 || randomDate.getDay() === 6); // Skip weekends

  const patientIndex = Math.floor(Math.random() * 5) + 1; // Use first 5 patients for appointments
  const isAiBooked = Math.random() > 0.4; // 60% AI booked
  const bookingMethod = bookingMethods[Math.floor(Math.random() * bookingMethods.length)];

  dummyAppointments.push({
    id: i.toString(),
    patientId: patientIndex.toString(),
    patientName: ['Maria Elena Rodriguez', 'James Patterson', 'Dr. Ashley Chen', 'Roberto Gonzalez', 'Jennifer Walsh'][patientIndex - 1],
    date: randomDate.toISOString().split('T')[0],
    time: `${String(Math.floor(Math.random() * 8) + 9).padStart(2, '0')}:${['00', '30'][Math.floor(Math.random() * 2)]}`,
    type: appointmentTypes[Math.floor(Math.random() * appointmentTypes.length)],
    status: statuses[Math.floor(Math.random() * statuses.length)],
    duration: [30, 60, 90, 120][Math.floor(Math.random() * 4)],
    notes: isAiBooked ? bookingMethod : 'Staff booked appointment',
    aiBooked: isAiBooked,
    assignedDoctor: doctors[Math.floor(Math.random() * doctors.length)]
  });
}
